import { Button, Tooltip } from 'antd';
import { type ButtonProps } from 'antd/lib/button';
import { useState, type ReactNode } from 'react';
import { ModalDialog, type ModalDialogProps } from '../modal/ModalDialog';

interface ModalButtonProps extends Omit<ButtonProps, 'onClick' | 'children'> {
  buttonChildren?: ReactNode;
  children: ReactNode;
  tooltip?: string;
  modalProps?: Omit<ModalDialogProps, 'children'>;
  onOk?: () => void;
  onCancel?: () => void;
  onOpen?: () => void;
  fieldName?: string;
}

export function ModalButton(props: ModalButtonProps) {
  const {
    children,
    tooltip = props.title,
    onOk,
    onCancel,
    onOpen,
    modalProps = {},
    buttonChildren,
    fieldName,
    ...buttonProps
  } = props;
  modalProps.title = modalProps.title ?? props.title;
  const [open, setOpen] = useState(false);

  const handleOk = () => {
    onOk?.();
    setOpen(false);
  };

  const handleCancel = () => {
    onCancel?.();
    setOpen(false);
  };

  const handleOpen = () => {
    onOpen?.();
    setOpen(true);
  };

  return (
    <>
      <Tooltip title={tooltip}>
        <Button
          {...buttonProps}
          children={buttonChildren}
          onClick={handleOpen}
          data-form-focusable-for={fieldName}
        />
      </Tooltip>

      <ModalDialog
        open={open}
        onOk={handleOk}
        onCancel={handleCancel}
        destroyOnClose
        {...modalProps}
      >
        {children}
      </ModalDialog>
    </>
  );
}

export default ModalButton;
